import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { IconButton } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { formatDate, formatRoleStringPretty } from "utils/Utils";
import ConfirmationModal from "views/components/ConfirmationModal";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import ToastModal from "views/components/ToastModal";
import { designationTableColumns } from "assets/properties/properties";
import { particularDesignationAccess } from "assets/properties/properties";

const Designation = () => {
  const navigate = useNavigate();
  const { authToken } = useSelector((state) => state.login.authData);
  const [rawData, setRawData] = useState([]);
  const [selectedTableData, setSelectedTableData] = useState([]);
  const [callInProgress, setCallInProgress] = useState(false);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalHeader, setConfirmationModalHeader] = useState("");
  const [confirmationModalMsg, setConfirmationModalMsg] = useState("");
  const [deleteDesignationId, setDeleteDesignationId] = useState("");
  const { userDetails } = useSelector((state) => state.userDetail.userDetails);

  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  const handleCreateDesignation = () => {
    navigate(`/coreservice/designation-create`);
  };
  useEffect(() => {
    getDesignationData();
  }, []);

  const getDesignationData = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.DESIGNATION_FINDALL,
      authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      setRawData(result?.data || []);
   const filteredData = result?.data?.filter((item) => !particularDesignationAccess.includes(item?.designation));
      const desingationWise = particularDesignationAccess.includes(userDetails?.designation) ? result?.data :  filteredData;
      parseDesignationData(desingationWise || []);
    }
  };
  const parseDesignationData = (data) => {
    const tableData = data.map((designation) => ({
      designation: formatRoleStringPretty(designation.designation),
      name: designation.level,
      action: getActionIcons(designation.designation, designation?.id),
    }));
    setSelectedTableData(tableData);
  };
  const getActionIcons = (designationId, id) => (
    <>
      <IconButton
        aria-label="Edit Designation"
        onClick={() =>
          navigate(`/coreservice/designation-create/${id}`)
        }
      >
        <EditIcon />
      </IconButton>

      <IconButton
        aria-label="Delete Designation"
        onClick={() => onClickDeleteDesignation(designationId)}
      >
        <DeleteIcon />
      </IconButton>
    </>
  );

  const onClickDeleteDesignation = (designationId) => {
    setConfirmationModalHeader("Designation");
    setConfirmationModalMsg("Are you sure you want to delete this designation?");
    setDeleteDesignationId(designationId);
    setConfirmationModal(true);
  };

  const handleNegativeResponse = () => {
    setConfirmationModal(false);
    setConfirmationModalHeader("");
    setConfirmationModalMsg("");
    setDeleteDesignationId("");
  };

  const handlePositiveResponse = async () => {
    handleNegativeResponse();
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.DESIGNATION_DELETE + deleteDesignationId,
      method: "DELETE",
      authToken,
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
    } else {
      toastUpdate("Success", "Designation deleted successfully", true);
      getDesignationData();
    }
  };
  const onSearchChange = (event) => {
    const val = event.target.value.toLowerCase();
    const filteredData = rawData.filter((row) => {
      const createDate = formatDate(row.createdDate)?.toLowerCase();
      const updatedDate = formatDate(row.updatedDate)?.toLowerCase();
      return (
        row.role?.toLowerCase().includes(val) ||
        row.name?.toLowerCase().includes(val) ||
        createDate?.includes(val) ||
        updatedDate?.includes(val)
      );
    });
    parseDesignationData(filteredData);
  };

  return (
    <GridContainer>
      <GridItem xs={12}>
        <SubHeader
          label="Designations"
          onSearchChange={onSearchChange}
          searchLabel="Search for Designations"
          search
          onAddClick={handleCreateDesignation}
          button1="Create Designation"
          button1click={handleCreateDesignation}
        />
      </GridItem>

      <GridItem xs={12}>
        <ColumnGroupingTable
          columns={designationTableColumns}
          rows={selectedTableData}
        />
      </GridItem>

      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}

      {callInProgress && (
        <CircularProgresss callInProgress={callInProgress} />
      )}

      <ConfirmationModal
        confirmationModal={confirmationModal}
        confirmationModalHeader={confirmationModalHeader}
        confirmationModalMsg={confirmationModalMsg}
        handleNegativeButton={handleNegativeResponse}
        handlePositiveButton={handlePositiveResponse}
      />
    </GridContainer>
  );
};

export default Designation;
